import React from 'react';
import { FormGroup } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import filters from '../../../models/filter';
import mapContext from '../../../contexts/map-context';
import { FilterItem } from './FilterItem';

export default function Filters() {
  const { authorDefinedFilters, userSelectedFilters, preselectedFilters } =
    mapContext.useMapState();

  return (
    <div data-test-id="filters-component">
      <FormGroup>
        {authorDefinedFilters.map((filterKey: string) => {
          return (
            <FilterItem
              key={filterKey}
              filterKey={filterKey}
              label={useI18n(filters[filterKey])}
              isSelected={
                preselectedFilters.includes(filterKey) || userSelectedFilters.includes(filterKey)
              }
              readOnly={preselectedFilters.includes(filterKey)}
              data-test-id="component-filter-item"
            />
          );
        })}
      </FormGroup>
    </div>
  );
}
